import  { useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';

function MarqueeManual({mensajes})
  {   
    const containerRef = useRef(null);   
    const textRef = useRef(null);    
    const [index, setIndex] = useState(0);   
    const [offset, setOffset] = useState(0);   
    const velocidad = 100;     
    useEffect(() =>      
      {  
        if (!mensajes.length) return;
        const container = containerRef.current;
        const text = textRef.current;
        
        if (!container || !text) return;
        const contW = container.offsetWidth; 
        const textW = text.offsetWidth;
        const distanciaTotal = 6*contW;
        const duracion = distanciaTotal / velocidad;

        let start = null;
         let rafId;
        
        const animar = (timestamp) => {
           if (!start) start = timestamp;

          const elapsed = (timestamp - start) / 1000; // segundos transcurridos
          const recorrido = elapsed * velocidad;

          // Desde fuera a la derecha hacia fuera a la izquierda
          const nuevaPos = contW - recorrido;
          setOffset(nuevaPos);

          if (elapsed < duracion) {
            rafId = requestAnimationFrame(animar);
          } else {
            // Esperar un momento antes de pasar al siguiente mensaje
            setTimeout(() => {
             setIndex((prev) => (prev + 1) % mensajes.length);
           }, 10);
          }
        };

         setOffset(contW);
         rafId = requestAnimationFrame(animar);

         return () => cancelAnimationFrame(rafId)
        }, [index]);    
  return (
    <div ref={containerRef} className="relative w-full h-20 overflow-hidden">
       <div ref={textRef} className="absolute w-full h-full text-center text-gray-700 font-semibold text-[2.8rem] whitespace-nowrap"
            style={{transform: `translateX(${offset}px)`, transition: "transform 0s linear",}}
       >
           {mensajes[index].Mensaje}
        </div>
    </div>
  );
}
MarqueeManual.propTypes = {
  mensajes: PropTypes.array.isRequired,
}  
export default MarqueeManual;